export const SET_PRODUCTS = "adminProduct/SET_PRODUCTS";
export const SET_PRODUCT = "adminProduct/SET_PRODUCT";
